<!-- banner -->
<div style="width:100%; background-color: white">
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <div class=""  fxLayout="row" fxLayoutAlign="space-between center">
      <div class="colorPracticas" >
        <h3>{{'RESULTADOS.4ALL.TITULO4ALL' | translate}}</h3>
      </div>
    </div>
    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
      <img src="assets/images/icons/4all_2.png" class="img4all">
    </div>
    </div>
  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'RESULTADOS.4ALL.CARGANDO' | translate}}</h1>
    </div>
  </ng-container>
  <ng-container *ngIf="!cargando">
  <ng-container *ngIf="datosChange">
    <div class="">
      <mat-tab-group mat-align-tabs="end">
        <mat-tab label="{{'RESULTADOS.4ALL.TABPRACTICAS.TITULOTAB' | translate}}">

          <!--cuadro  1 -->
          <div class="" fxLayout="row" >
            <div class="mat-card mat-elevation-z4  mr-24" fxLayout="column" fxFlex="30"  >
              <div class="header" fxLayout="row" fxLayoutAlign="center center">
                <div class="category">
                  {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.SUBTITULOPRAC' | translate}}
                </div>
              </div>

              <div  class="p-24" fxLayout="row">
                <span class="subtitle">
                  {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.TEXTO1' | translate}}
                  <span class="text-success2">{{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.TEXTO2' | translate}}</span>
                  {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.TEXTO3' | translate}}
                </span>
              </div>

              <div class="" fxLayout="row" >
                <canvas baseChart width="300px" height="150px"
                [data]="doughnutChartDataConocimiento"
                [labels]="doughnutChartLabelsConocimiento"
                [chartType]="doughnutChartType"
                [colors]="donutColorsConocimiento"
                [plugins]="doughnutChartPluginsConocimiento"
                [options]="doughnutChartOptionsConocimiento"
                >
              </canvas>
              <!-- <div class="donut-inner">
              <h5>47 / 60 st</h5>
              <span>(30 / 25 st)</span>
            </div> -->
          </div>

          <div class="p-24" fxLayout="row">
            <span class="subtitle">
              {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.TEXTO4' | translate}}
              <span class="text-warning2">   {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.TEXTO5' | translate}} </span>
              {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRACGLOBAL.TEXTO6' | translate}}
            </span>
          </div>
          <div class="" fxLayout="row">
            <canvas baseChart width="300px" height="150px"
            [data]="doughnutChartDataSatisfaccion"
            [labels]="doughnutChartLabelsSatisfaccion"
            [chartType]="doughnutChartType"
            [colors]="donutColorsSatisfaccion"
            [plugins]="doughnutChartPluginsSatisfaccion"
            [options]="doughnutChartOptionsSatisfaccion"
            >
          </canvas>
        </div>

      </div>
      <!--cuadro  2 -->

      <div    class="mat-card mat-elevation-z4  mr-24" fxLayout="column" fxFlex="70" fxLayoutAlign="start ">
        <div class="header2" fxLayout="row" fxFlex="100">
          <div class="category2">
            {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.SUBTITULO4ALL' | translate}}
          </div>
        </div>

        <div class="" fxLayout="row">
          <div class="" fxLayout="column" style="margin-top: 18px;" fxFlex="35" >
            <div class="" fxLayout="row" *ngFor="let resultado of resultados4ll.resultado" style="margin-top: 29px;" >
              <div  fxLayout="column" >
                <h5 class=" txtPractica">{{resultado.practica}}</h5>
              </div>
            </div>
          </div>
          <div class="" fxLayout="column" fxFlex="34">
            <div class="marginConocimiento" fxLayout="row" >
              <span class="text-success2">  {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TITULOCONO' | translate}}</span>
            </div>
            <div class="" fxLayout="row" >
              <span class="text">
                {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TEXTO1' | translate}}</span>
              </div>
              <div class="" fxLayout="row" *ngFor="let resultado of resultados4ll.resultado">
                <div class="" fxLayout="row" fxflex="100">
                  <div class="" fxLayout="column">
                    <mat-progress-bar class="prro " mode="Determinate" value="{{resultado.conocimiento}}"></mat-progress-bar>
                    <h4 class=" midText">{{resultado.conocimiento | number:'1.0-0'}}%</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="" fxLayout="column" fxFlex="34" >
              <div class="marginSatisfaccion" fxLayout="column">
                <span class="text-warning2">{{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TITULOSATIS' | translate}}</span>
              </div>
              <div class="" fxLayout="column">
                <span class="text">
                  {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TEXTO2' | translate}}
                </span>
              </div>
              <div class="" fxLayout="row" *ngFor="let resultado of resultados4ll.resultado" fxflex="100" >
                <div class="" fxLayout="row" >
                  <div class="" fxLayout="column">


                    <mat-progress-bar class="perro"mode="Determinate" value="{{resultado.satisfaccion}}"></mat-progress-bar>
                    <h4 class=" midText">{{resultado.satisfaccion | number:'1.0-0'}}%</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="" fxLayout="row" >
          <div class="margin" fxLayout="column" style="background: blue;">
          <span class="text-success2">  {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TITULOCONO' | translate}}</span>
          <span>
          {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TEXTO1' | translate}}</span>
        </div>
        <div class="marginSatisfaccion" fxLayout="column">
        <span class="text-warning2">{{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TITULOSATIS' | translate}}</span>
        <span>
        {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TEXTO2' | translate}}
      </span>
    </div>
  </div> -->


  <!-- <div class="" fxLayout="row" *ngFor="let resultado of resultados4ll.resultado" >
  <div class="txtPractica" fxLayout="column" >
  {{resultado.practica}}
</div>
<div class="" fxLayout="column">
<mat-progress-bar class="prro " mode="Determinate" value="{{resultado.conocimiento}}"></mat-progress-bar>
<h4 class=" midText">{{resultado.conocimiento | number:'1.0-0'}}%</h4>
</div>
<div class="" fxLayout="column">
<mat-progress-bar class="perro"mode="Determinate" value="{{resultado.satisfaccion}}"></mat-progress-bar>
<h4 class=" midText">{{resultado.satisfaccion | number:'1.0-0'}}%</h4>
</div>
</div> -->

</div>
</div>





</mat-tab>
<!-- demograficos -->
<mat-tab label=" {{'RESULTADOS.4ALL.TABPRACTICAS.TITULOPRAC4All.TITULOTAB' | translate}}">

  <!--cuadro  1 -->
  <div class="" fxLayout="row" >
    <div class="demograficos1" fxLayout="column" fxFlex="10"  >
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" vertical="true" class="example-button-row">

        <mat-button-toggle value="bold" class=""  *ngFor="let resultado of resultados4ll.resultado2;let i = index;" (click)="cambiaSeccion(resultado.demograficoId)">
          <div class="divmargin" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="classicon">{{iconosFiltrados[i]}}</mat-icon>
            {{'RESULTADOS.4ALL.DEMOGRAFICOS.'+resultado.demografico | translate}}
          </div>
        </mat-button-toggle>


      </mat-button-toggle-group>





    </div>
    <!--cuadro  2 -->

    <div class="demograficos" fxLayout="column" fxFlex="90">
      <div fxLayout="row"class="margenText">
        <div style="width: 20px; height: 17.5px; background: #087272; float: left;">
        </div>
        <span class="marginConocimiento">{{'RESULTADOS.4ALL.DEMOGRAFICOS.PORCONOTXT1' | translate}}
          <span class="text-success2">{{'RESULTADOS.4ALL.DEMOGRAFICOS.PORCONOTXT2' | translate}}</span>
          {{'RESULTADOS.4ALL.DEMOGRAFICOS.PORCONOTXT3' | translate}}</span>
        </div>
        <div  fxLayout="row">
          <div style="width: 20px; height: 17.5px; background: #FF613A; float: left;"></div>
          <span class="marginConocimiento">{{'RESULTADOS.4ALL.DEMOGRAFICOS.PORSATITXT1' | translate}}
            <span class="text-warning2">{{'RESULTADOS.4ALL.DEMOGRAFICOS.PORSATITXT2' | translate}}</span>
            {{'RESULTADOS.4ALL.DEMOGRAFICOS.PORSATITXT3' | translate}}</span>
          </div>
          <ng-container *ngIf="seccionesOcultas">
            <div  class="" fxLayout="row wrap">
              <div class="" fxLayout="column" *ngFor="let demograficos of segmentosSeleccionados" fxFlex="33">
                <div class="header tituloDemografico"  fxLayout="row " fxLayoutAlign="center center">
                  <div class="category3 ">
                    {{demograficos.segmento}}
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                  <app-graficabarra class="tamañoGrafica"
                  [conocimiento]="demograficos.conocimiento"
                  [satisfaccion]="demograficos.satisfaccion"
                  ></app-graficabarra>

                </div>

              </div>
            </div>
          </ng-container>


        </div>
      </div>





    </mat-tab>

  </mat-tab-group>
</div>
</ng-container>
<ng-container *ngIf="!datosChange">
  <div class="NO_FORALL" fxLayout="column" fxLayoutAlign="center center">
  <h1 class="h1 secondary-text"><p class="texto">{{'RESULTADOS.4ALL.MODL_N_RESU_4ALL' | translate}}</p></h1>
  </div>

</ng-container>
</ng-container>

</div>
